module.exports = __webpack_public_path__ + "img/ae10.65c7fb84.jpg";